import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Toast } from 'primereact/toast';
import './drop-file-input-array.css';

import { ImageConfig } from '../../config/ImageConfig';
import uploadImg from '../../assets/cloud-upload-regular-240.png';
import { Col, Row } from 'react-bootstrap';
import { table } from '@nextui-org/react';



const DropFileInputArray = (props) => {
    const wrapperRef = useRef(null);
    const toast = useRef(null);
    
    const fileListindex = props.fileList?.findIndex(item => item.index === props.index);
    useEffect(() => {

        props.CheckProofDocRequired(props.table, props.nameofFile, props.index);
    }, [props.values[props.table][props.index]]);


    const onDragEnter = () => wrapperRef.current.classList.add('dragover');
    const onDragLeave = () => wrapperRef.current.classList.remove('dragover');
    const onDrop = () => wrapperRef.current.classList.remove('dragover');

    const onFileDrop = (e) => {
        var newFile = e.target.files[0];
        const maxSizeInBytes = 5 * 1024 * 1024;
        const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
        if (!allowedTypes.includes(newFile.type)) {
            toast.current.clear();
            toast.current.show({
                severity: 'error',
                summary: 'Invalid file type',
                description: "Please upload an image (JPEG/PNG) or a PDF"
                ,
                life: 3000,
                sticky: false,
                content: (props) => (
                    <div className="p-3" style={{ flex: '1' }}>
                        <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                        <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                    </div>
                ),
            });

        } else
            if (newFile.size > maxSizeInBytes) {
                toast.current.clear();
                toast.current.show({
                    severity: 'error',
                    summary: 'File size exceeds the limit',
                    description: "Please upload a file less than 5 MB"
                    ,
                    life: 3000,
                    sticky: false,
                    content: (props) => (
                        <div className="p-3" style={{ flex: '1' }}>
                            <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                            <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                        </div>
                    ),
                });
            } else
                if (newFile) {
                    const currentData = props.values[props.table][props.index];
                    const targetIndex = props.index;
                    const updatedList = [...props.fileList];
                    const targetItem = updatedList.find(item => item.index === targetIndex);

                    if (targetItem) {
                        targetItem.file = [...targetItem.file, newFile];
                    } else {

                        updatedList.push({
                            index: targetIndex,
                            file: [newFile],
                        });
                    }

                    props.setFileList(updatedList)

                    const updatedData = {
                        ...currentData,
                        proof_doc: [
                            ...(currentData.proof_doc || [""]), ,
                            {
                                file: newFile,
                                name: props.nameofFile,
                            },
                        ].filter(item => item.file),
                    };



                    const updatedDataArray = [...props.values[props.table]];
                    updatedDataArray[props.index] = updatedData;


                    props.setFieldValue([props.table], updatedDataArray);


                }

    };
    const fileRemove = (file) => {



        if (fileListindex !== -1) {
            const updatedList = [...props.fileList];
            props.fileList[fileListindex].file.splice(props.fileList.indexOf(file), 1);
            props.setFileList(updatedList);
        }

        const currentData = props.values[props.table][props.index];

        const updatedProofDoc = currentData.proof_doc.filter((item) => {


            return (item.file) != (file);
        });

        const updatedData = {
            ...currentData,
            proof_doc: updatedProofDoc,
        };

        const updatedDataArray = [...props.values[props.table]];
        updatedDataArray[props.index] = updatedData;

        props.setFieldValue([props.table], updatedDataArray);

    };


    return (
        <div className='d-flex justify-content-center flex-column' style={{ width: "100%" }}>

            <Toast ref={toast} position="top-center" />
            <label className='pt-3 ps-3' style={{ height: "100%" }}>Proof Documents</label>
            {props.error && <small style={{ color: "red" }} className=' ps-3'>{props.error}</small>}

            <table style={{ fontSize: '13px' , marginLeft:'15px'}}>
                <tbody>
                    <tr>
                        <td>NIC Proof</td>
                        <td>: Valid government-issued photo identification required, such as a passport, driver's license, or national ID card.</td>
                    </tr>
                    <tr>
                        <td>Address Proof</td>
                        <td>: Recent utility bill, bank statement, or lease agreement showing current address, issued within the last three months.</td>
                    </tr>
                    <tr>
                        <td>Name Proof</td>
                        <td>: Legal document indicating name change, such as a marriage certificate, divorce decree, or court order.</td>
                    </tr>
                </tbody>
            </table>

            
            <Row className='my-4'>
                <Col xs={12}>
                    <div
                        ref={wrapperRef}
                        className={`drop-file-input`}
                        onDragEnter={onDragEnter}
                        onDragLeave={onDragLeave}
                        onDrop={onDrop}
                        style={{ borderColor: `${props.error ? 'red' : '#11B1F0'}` }}
                    >
                        <div className="drop-file-input__label d-flex justify-content-center flex-column">
                            <div className='d-flex justify-content-center'>
                                <img src={uploadImg} alt="" />
                            </div>
                            <p>Drag & Drop your files here</p>
                        </div>
                        <input type="file" name='nominee_proof_doc' onChange={onFileDrop} required />
                    </div>
                </Col>

            </Row>
            <Row>
                <Col xs={12}>
                    {props.fileList?.[fileListindex]?.file?.length > 0 ? (
                        <div className="drop-file-preview">
                            <p className="drop-file-preview__title">
                                Ready to upload
                            </p>
                            {props.fileList?.[fileListindex]?.file?.map((item, index) => {
                                const maxLength = 20; 
                                const fileName = item?.name;

                                
                                if (fileName.length > maxLength) {
                                   
                                    const extensionIndex = fileName.lastIndexOf('.');
                                    const namePart = fileName.substring(0, extensionIndex);
                                    const extension = fileName.substring(extensionIndex);

                                    
                                    const truncatedName = namePart.substring(0, maxLength - extension.length) + '...';

                                  
                                    const truncatedFileName = truncatedName + extension;

                                    return (
                                        <div key={index} className="drop-file-preview__item">
                                            <img src={ImageConfig[item?.type?.split('/')[1]] || ImageConfig['default']} alt="" />
                                            <div className="drop-file-preview__item__info">
                                                <p>{truncatedFileName}</p>
                                                {item?.file && <p>{item.file.size}B</p>}
                                            </div>
                                            <span className="drop-file-preview__item__del" onClick={() => fileRemove(item)}>x</span>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div key={index} className="drop-file-preview__item">
                                            <img src={ImageConfig[item?.type?.split('/')[1]] || ImageConfig['default']} alt="" />
                                            <div className="drop-file-preview__item__info">
                                                <p>{fileName}</p>
                                                {item?.file && <p>{item.file.size}B</p>}
                                            </div>
                                            <span className="drop-file-preview__item__del" onClick={() => fileRemove(item)}>x</span>
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    ) : null}
                </Col>

            </Row>
        </div>
    );
};

DropFileInputArray.propTypes = {
    onFileChange: PropTypes.func,
};

export default DropFileInputArray;
